// action types
export const SELECT_PROGRAM_GROUP = "selectProgramGroup";
export const UNSELECT_PROGRAM_GROUP = "unselectProgramGroup";

// mutation types
export const SET_PROGRAM_GROUP = "setProgramGroup";
export default {
  state: {
    programGroup: null
  },
  getters: {
    /**
     * Get current selected program group
     * @param state
     * @returns {*}
     */
    selectedProgramGroup(state) {
      return state.programGroup;
    }
  },
  actions: {
    /**
     * Select program group
     * @param state
     * @param payload
     */
    [SELECT_PROGRAM_GROUP](state, payload) {
      state.commit(SET_PROGRAM_GROUP, payload);
    },

    /**
     * Unselect program group
     * @param state
     * @param payload
     */
    [UNSELECT_PROGRAM_GROUP](state) {
      state.commit(SET_PROGRAM_GROUP, null);
    }
  },
  mutations: {
    [SET_PROGRAM_GROUP](state, payload) {
      state.programGroup = payload;
    }
  }
};
